module.exports = __webpack_public_path__ + "img/launch.f925b849.jpg";